(function ($) {
  $(document).ready(function () {
    /* ==========
      Product Page
    ========== */

    if ($(".template-product").length) {
      var check_sc_counter = 0;

      var check_sc = setInterval(function () {
        var $sc = $(".ks-chart-container");

        if ($sc.length) {
          clearInterval(check_sc);

          $(".rp_box-size").append($sc);
          $sc.addClass("active");
        } else if (check_sc_counter > 10000) {
          clearInterval(check_sc_counter);
        }

        check_sc_counter += 100;
      }, 100);
    }


    /* ==========
      Current Product
    ========== */

    if (window.swatch_current_product) {

      var current_product = window.swatch_current_product;
      var products_array = window.swatch_products_array;
      var is_fixed_pad = current_product.title.toLowerCase().includes("fixed pads");
      var is_ultra_comfort = is_fixed_pad && current_product.title.toLowerCase().includes("ultra comfort");
      var is_ultra_soft = is_fixed_pad && current_product.title.toLowerCase().includes("ultra soft");
      var is_bra = !is_fixed_pad && current_product.title.toLowerCase().includes("nursing bra");
      var colors_array = [];
      var colors_obj = {
        "pink_clouds": "/cdn/shop/t/5/assets/bra-pink-clouds.png",
        "black_camo": "/cdn/shop/t/5/assets/bra-black-camo.png",
        "solid_black": "/cdn/shop/t/5/assets/bra-black.png",
        "cabernet": "/cdn/shop/t/5/assets/bra-cabernet.png",
        "heathered_black": "/cdn/shop/t/5/assets/bra-heathered-black.png",
        "heathered_bronze": "https://cdn.shopify.com/s/files/1/0675/1797/2795/files/bra-heathered-bronze.png",
        "heathered_jade": "/cdn/shop/t/5/assets/bra-heathered-jade.png",
        "lavender": "/cdn/shop/t/5/assets/bra-lavender.png",
        "midnight_chevron": "/cdn/shop/t/5/assets/bra-midnight-chevron.png",
        "olive": "/cdn/shop/t/5/assets/bra-olive.png",
        "steel_python_mombra": "/cdn/shop/t/5/assets/bra-steel-python.png",
        "white_camo": "/cdn/shop/t/5/assets/bra-white-camo.png",
        "white_python": "/cdn/shop/t/5/assets/bra-white-python.png",
        "burnt_orange": "/cdn/shop/t/5/assets/bra-burnt-orange.png",
        "gray_tie_dye": "/cdn/shop/t/5/assets/bra-gray-tie-dye.png",
      }

      if (is_fixed_pad) {
        // ultra comfort
        if (is_ultra_comfort) {
          products_array = products_array.filter(({ title }) => title.toLowerCase().includes("fixed pads") && title.toLowerCase().includes("ultra comfort"));  
        } else if (is_ultra_soft) {
          products_array = products_array.filter(({ title }) => title.toLowerCase().includes("fixed pads") && title.toLowerCase().includes("ultra soft"));  
        }
      } else if (is_bra) {
        products_array = products_array.filter(({ title }) => !title.toLowerCase().includes("fixed pads") && title.toLowerCase().includes("nursing bra"));
      } else {
        products_array = false;
      }

      //console.log(products_array);

      if (!products_array) return;

      products_array.forEach(({ title, handle }) => {

        var color_match = title.match(/\(([^)]+)\)/);
        if (color_match) {
          var color = color_match[1];
          var color_img = color.toLowerCase().replaceAll(" ", "_");

          colors_array.push({ title, color, handle, img: colors_obj[color_img]})
        }

      })

      var colors_array_html = "<ul>" + colors_array.map((({ title, color, handle, img }) => {

        //if (!img) return "";

        return `<li ${title === current_product.title ? `class="rp_box-selected"` : ""}><a href="${handle}" title="${color}"><img src="${img}"></a></li>`

      })).join("") + "</ul>";

      $(".rp_box-color").append(colors_array_html);

      
    }

  });
})(jQuery);
